import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import DCActions, { dcActionTypes } from '../actions/dcActions';
import DCServices from '../services/dcServices';

/**
 * @param action
 */
function* _createDC(action,callback) {
  try {
    yield put(DCActions.createDCLoading(true));
    const dc = yield DCServices.createDC(action.payload);
    if (dc.success) {
      yield put(TrackerActions.trackAction(dcActionTypes.CREATE_DC.SUCCESS, dc.data));
      notification.open({
        type: 'success',
        message: ' Delivery Challan successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(dc?.data?.[0]|| dc);
    } else {
      notification.open({
        type: 'error',
        message: dc.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.createDCLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      position: 'top',
    });
    yield put(DCActions.createDCLoading(false));
    yield put(TrackerActions.trackAction(dcActionTypes.CREATE_DC.ERROR, error));
  }
}

/**
 *
 */
function* createDC() {
  yield takeLatest(dcActionTypes.CREATE_DC.REQUEST, _createDC);
}

/**
 * @param action
 */
function* _updateDC(action) {
  try {
    yield put(DCActions.updateDCLoading(true));
    const dc = yield DCServices.updateDC(action.payload);
    if (dc.success) {
      yield put(TrackerActions.trackAction(dcActionTypes.UPDATE_DC.SUCCESS, dc.data));
      notification.open({
        type: 'success',
        message: 'Delivery Challan successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(DCActions.updateDCLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DCActions.updateDCLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(DCActions.updateDCLoading(false));
    yield put(TrackerActions.trackAction(dcActionTypes.UPDATE_DC.ERROR, error));
  }
}

/**
 *
 */
function* updateDC() {
  yield takeLatest(dcActionTypes.UPDATE_DC.REQUEST, _updateDC);
}

/**
 * @param action
 */
function* _getDC(action) {
  try {
    DCActions.getDCSuccess(null);
    yield put(DCActions.getDCLoading(true));
    const {
      tenantId, stockTransferId, challanId, limit, page, searchKeyword, department, secondaryStatus, is_list
    } = action;
    const deliveryChallan = yield DCServices.getDC(tenantId, stockTransferId, challanId, limit, page, searchKeyword, '', '', department, secondaryStatus, is_list);
    yield put(DCActions.getDCSuccess(deliveryChallan));
    yield put(DCActions.getDCLoading(false));
  } catch (error) {
    yield put(DCActions.getDCLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.GET_DC.ERROR, error));
  }
}

/**
 *
 */
function* getDC() {
  yield takeLatest(dcActionTypes.GET_DC.REQUEST, _getDC);
}

/**
 * @param action
 */
function* _getDCById(action) {
  try {
    yield put(DCActions.getDCByIdLoading(true));
    const {
      tenantId, tenantSellerId, dcId, searchKeyword,
    } = action;
    const selectedDC = yield DCServices.getDC(tenantId, tenantSellerId, dcId, searchKeyword);
    yield put(DCActions.getDCByIdSuccess(selectedDC?.result?.delivery_challans[0]));
    yield put(DCActions.getDCByIdLoading(false));
    if (action?.callback) {
      action.callback();
    }
  } catch (error) {
    yield put(DCActions.getDCByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.GET_DC_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getDCById() {
  yield takeLatest(dcActionTypes.GET_DC_BY_ID.REQUEST, _getDCById);
}

/**
 * @param action
 */
function* _updateDCStatus(action) {
  try {
    yield put(DCActions.updateDCStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const dc = yield DCServices.updateDCStatus(payload);

    if (dc.success) {
      notification.open({
        type: 'success',
        message: ' Delivery challan status has been updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.updateDCStatusLoading(false));
  } catch (error) {
    yield put(DCActions.updateDCStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.UPDATE_STATUS_DC.ERROR, error));
  }
}

/**
 *
 */
function* updateDCStatus() {
  yield takeLatest(dcActionTypes.UPDATE_STATUS_DC.REQUEST, _updateDCStatus);
}

/**
 * @param action
 */
function* _deleteDC(action) {
  try {
    yield put(DCActions.deleteDCLoading(true));
    const dc = yield DCServices.deleteDC(action.payload?.challan_id);

    if (dc.success) {
      notification.open({
        type: 'success',
        message: 'Delivery challan has been deleted successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.deleteDCLoading(false));
  } catch (error) {
    yield put(DCActions.deleteDCLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.DELETE_DC.ERROR, error));
  }
}

/**
 *
 */
function* deleteDC() {
  yield takeLatest(dcActionTypes.DELETE_DC.REQUEST, _deleteDC);
}

function* _updateDCWorkflowStep(action) {
  try {
    yield put(DCActions.updateDCWorkflowStepLoading(true));
    const dc = yield DCServices.updateDCWorkflowStep(action.payload);

    if (dc.success) {
      notification.open({
        type: 'success',
        message: 'Workflow step has been updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.updateDCWorkflowStepLoading(false));
  } catch (error) {
    yield put(DCActions.updateDCWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.UPDATE_DC_WORKFLOW_STEP.ERROR, error));
  }
}

function* updateDCWorkflowStep() {
  yield takeLatest(dcActionTypes.UPDATE_DC_WORKFLOW_STEP.REQUEST, _updateDCWorkflowStep);
}

/**
 *
 */

function* _updateDeliveryChallanStatus(action) {
  try {
    yield put(DCActions.updateDeliveryChallanStatusLoading(true));
    const dc = yield DCServices.updateDeliveryChallanStatus(action.payload);

    if (dc.success) {
      notification.open({
        type: 'success',
        message: 'Delivery challan status has been updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.updateDeliveryChallanStatusLoading(false));
  } catch (error) {
    yield put(DCActions.updateDeliveryChallanStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.UPDATE_DELIVERY_CHALLAN_STATUS.ERROR, error));
  }
}

function* updateDeliveryChallanStatus() {
  yield takeLatest(dcActionTypes.UPDATE_DELIVERY_CHALLAN_STATUS.REQUEST, _updateDeliveryChallanStatus);
}

function* _quickUpdateDeliveryChallan(action) {
  try {
    yield put(DCActions.quickUpdateDeliveryChallanLoading(true));
    const dc = yield DCServices.quickUpdateDeliveryChallan(action.payload);

    if (dc.success) {
      notification.open({
        type: 'success',
        message: 'Delivery challan has been updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: dc?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(DCActions.quickUpdateDeliveryChallanLoading(false));
  } catch (error) {
    yield put(DCActions.quickUpdateDeliveryChallanLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(dcActionTypes.QUICK_UPDATE_DELIVERY_CHALLAN.ERROR, error));
  }
}

function* quickUpdateDeliveryChallan() {
  yield takeLatest(dcActionTypes.QUICK_UPDATE_DELIVERY_CHALLAN.REQUEST, _quickUpdateDeliveryChallan);
}

export default function* dcSaga() {
  yield all([
    createDC(), getDC(), updateDC(), getDCById(), updateDCStatus(), deleteDC(), updateDCWorkflowStep(),
    updateDeliveryChallanStatus(), quickUpdateDeliveryChallan(),
  ]);
}
